import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { UploadedFile } from '../../../../core/interfaces/file-upload-interfaces';
import { RecentUploadsService } from '../../../../core/services/recent-uploads.service';
import { UploadedFileComponent } from "../../../auth/components/onboarding/uploaded-file/uploaded-file.component";
import { FileUploadHelperService } from '../../../../core/services/file-upload-helper.service';

@Component({
  selector: 'app-invoice-upload-dialog',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, UploadedFileComponent],
  templateUrl: './invoice-upload-dialog.component.html',
  styleUrl: './invoice-upload-dialog.component.css'
})
export class InvoiceUploadDialogComponent implements OnChanges {
  modalDialogId: string = 'invoice_modal_upload'

  @Input() toast!: ToastComponent;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  get listOfRecentUploads(): UploadedFile[] {
    return this.recentUploads.getLastUploads(this.fileUploadHelper.getTotalUploadingNumber());
  }

  constructor(protected fileUploadHelper: FileUploadHelperService, private translocoService: TranslocoService, private recentUploads: RecentUploadsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.toast) {
      this.fileUploadHelper.attachToast(this.toast);
    }
  }

  openModal(withAutoFileSelect: boolean = false): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      if (withAutoFileSelect) {
        this.fileInput.nativeElement.click();
      }
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
    }
  }

  isUploadActive() {
    return this.recentUploads.hasPendingUploads();
  }

  stopClicked(id: number) {
    if (!this.recentUploads.stopUpload(id)) {
      return;
    }

    this.toast.showToast(this.translocoService.translate("shared.file_upload.canceled"), this.translocoService.translate("shared.file_upload.stopped"), "warning", 4000, false);

  }

  // Warn user if trying to leave while upload is in progress
  @HostListener('window:beforeunload', ['$event'])
  preventNavigation(event: BeforeUnloadEvent) {
    var isUploading = this.recentUploads.hasPendingUploads();

    if (isUploading) {
      event.preventDefault();
    }
  }
}
